import React, { useId } from 'react';
import { Path } from 'react-native-svg';
import { IconWithGradient } from './Icon';
export const IconPaint = (props) => {
    const id = useId();
    return (<IconWithGradient id={id} {...props} defaultGradientKey="apricot">
      <Path d="M4 6.125C4 4.951 4.951 4 6.125 4h9.563c1.172 0 2.124.951 2.124 2.125V8.25a2.127 2.127 0 0 1-2.125 2.125H6.126A2.126 2.126 0 0 1 4 8.25V6.125Zm5.313 9.563c0-.588.474-1.063 1.062-1.063v-.531a2.656 2.656 0 0 1 2.656-2.656h4.781c.588 0 1.063-.475 1.063-1.063V6.306A3.188 3.188 0 0 1 21 9.312v1.063a3.188 3.188 0 0 1-3.188 3.188h-4.78a.533.533 0 0 0-.532.53v.532c.588 0 1.063.475 1.063 1.063v4.25c0 .587-.475 1.062-1.063 1.062h-2.125a1.061 1.061 0 0 1-1.063-1.063v-4.25Z" fill={`url(#gradient_${id})`}/>
    </IconWithGradient>);
};
